import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function SnackbarComponent({ variant, handleClose, open, content }) {
  const Alert = React.forwardRef((props, ref) => (
    <MuiAlert elevation={6} ref={ref} {...props} />
  ));

  return (
    <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={variant}>
        {content}
      </Alert>
    </Snackbar>
  );
}

export default SnackbarComponent;
